import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Header, Button, Image, Table, Groupper, Message } from 'react-frontier';
import { Checkbox } from 'semantic-ui-react';
import MDEditor from '@uiw/react-md-editor/nohighlight';
import { addCommas } from '../SiteUtil';
import { ConfirmationData, SetLoading } from '../SiteClasses';
import API from '../API';
import moment from 'moment';

var WorkerConfirmation = ()=>{
	var { token } = useParams<{ token: string }>();
	var [loading, setLoading] = useState<boolean>(true);
	var [eventData, setData] = useState<ConfirmationData>(null);
	var [confirmed, setConfirmed] = useState<boolean>(false);
	var [declined, setDeclined] = useState<boolean>(false);
	var [loadError, setLoadError] = useState<string>(null);
	var [error, setError] = useState<string>(null);
	var [accepted, setAccepted] = useState<boolean>(false);

	useEffect(()=>{
		moment.locale('es');
		if(!token) return setLoadError('No existe una invitación válida para este enlace.');

		API.getWorkerConfirmation(token).then(res=>{
			if(res.error) return setLoadError(res.message);
			setData(res.data);
			setConfirmed(!!res.data.confirmed);
			setDeclined(!!res.data.declined);
		}).catch(()=>{
			setLoadError('Hubo un error inesperado cargando la invitación.');
		}).finally(()=>{
			setLoading(false);
		});
	}, [token]);

	var onDecline = (setLoading: SetLoading)=>{
		setError(null);
		setLoading(true);
		API.workerInvitationResponse(token, true).then(res=>{
			if(res.error) return setError(res.message);
			setDeclined(true);
		}).catch(()=>{
			setError('Hubo un error inesperado. Intenta de nuevo.');
		}).finally(()=>{
			setLoading(false);
		});
	};

	var onConfirm = (setLoading: SetLoading)=>{
		setError(null);
		setLoading(true);
		API.workerInvitationResponse(token, false).then(res=>{
			if(res.error) return setError(res.message);
			setConfirmed(true);
		}).catch(()=>{
			setError('Hubo un error inesperado. Intenta de nuevo.');
		}).finally(()=>{
			setLoading(false);
		});
	};

	if(loading) return <Header loading text='Cargando...' />;
	if(loadError) return <Header text='Error' subtext={loadError} />;
	if(declined) return <Header text='Invitación declinada' subtext={`Has declinado la invitación para ${eventData?.event_name}.`} />;
	if(!eventData) return null;

	return <>
		{confirmed && (
			<Message
				header='¡Tu asistencia ha sido confirmada!'
				text={`Gracias, ${eventData.worker_name}. Nos vemos el ${moment.unix(eventData.date).format('DD [de] MMMM [de] YYYY')} en ${eventData.event_name}.`}
				type='success'
				style={{ margin: 'auto', marginTop: 20, maxWidth: 600 }}
				centered
			/>
		)}
		<Groupper title={eventData.event_name} width={600} style={{ marginTop: 20, paddingBottom: 0 }}>
			{!confirmed && <Header text={`¡Hola, ${eventData.worker_name}!`} subtext='Te han invitado a trabajar en este evento.' size='small' centered />}
			{eventData.poster_url && (
				<div style={{ textAlign: 'center' }}>
					<Image src={eventData.poster_url} alt={eventData.event_name} height={250} style={{ borderRadius: 12 }} />
				</div>
			)}
			<Table
				title='Información de empleo'
				details
				fitted
				striped
				style={{ marginTop: 0, marginBottom: 0 }}
				data={[
					['Trabajador', eventData.worker_name],
					['Horario', moment.unix(eventData.date).format('DD MMMM YYYY, HH:mm')],
					['Puesto', eventData.title_name],
					['Pago', `$${addCommas(eventData.payout_amount)}`],
					...(eventData.venue_name || eventData.city ? [['Lugar', [eventData.venue_name, eventData.city].filter(Boolean).join(' — ')]] : []),
				]}
			/>
			{!confirmed && (
				<>
					{eventData.contract_content && (
						<>
							<Groupper.Divider text='Términos y Condiciones' style={{ fontSize: 18, fontWeight: 'bold', marginTop: 0 }} />
							<div data-color-mode='light'>
							<MDEditor.Markdown
								source={eventData.contract_content}
								style={{
									maxHeight: 300,
									overflowY: 'auto',
									backgroundColor: '#ffffff',
									padding: '10px',
									border: '1px solid #e0e0e0',
									borderRadius: 8,
									fontSize: 14,
									lineHeight: 1.6,
									color: '#222222',
								}}
							/>
						</div>
							<Checkbox
								style={{ marginTop: 20, marginBottom: 10 }}
								label='Declaro que he leído, entendido y aceptado los presentes Términos y Condiciones de Participación Eventual.'
								checked={accepted}
								onChange={(_, d) => setAccepted(!!d.checked)}
							/>
						</>
					)}
					{error && <Message type='error' text={error} />}
				<Button text='Confirmar' color='black' fluid disabled={eventData.contract_content ? !accepted : false} onClick={onConfirm} style={{ marginTop: 10, marginBottom: 5 }} />
				<Button text='Rechazar' color='red' fluid basic onClick={onDecline} style={{ marginBottom: 20 }} />
				</>
			)}
		</Groupper>
	</>;
};

export default WorkerConfirmation;

